import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { neonBlue } from '../../theme/colors';

const AuthLayout = ({ children, title, subtitle }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
      minHeight: '100vh',
      bgcolor: 'background.paper',
    }}
  >
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        p: { xs: 3, md: 6 },
      }}
    >
      <Box sx={{ maxWidth: 420, width: '100%' }}>
        <Stack spacing={1} sx={{ mb: 4 }}>
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ display: { lg: 'none' } }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1.5,
                bgcolor: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'primary.contrastText',
              }}
            >
              <LocalShippingIcon />
            </Box>
            <Typography variant="h6">Elite Riders</Typography>
          </Stack>
          {title && (
            <Typography variant="h4" fontWeight={500}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Stack>
        {children}
      </Box>
    </Box>

    <Box
      sx={{
        alignItems: 'center',
        bgcolor: neonBlue[600],
        color: 'common.white',
        display: { xs: 'none', lg: 'flex' },
        justifyContent: 'center',
        p: 6,
        background: `linear-gradient(135deg, ${neonBlue[600]} 0%, ${neonBlue[800]} 100%)`,
      }}
    >
      <Stack spacing={3} sx={{ maxWidth: 420 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LocalShippingIcon sx={{ fontSize: 32 }} />
        </Box>
        <Typography variant="h3" fontWeight={500}>
          Welcome to Elite Riders Delivery App
        </Typography>
        <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.85)' }}>
          Manage deliveries, orders, and customers from one dashboard.
        </Typography>
        <Stack spacing={1}>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            • Real-time order tracking
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            • Rider delivery portal
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            • Customer and user management
          </Typography>
        </Stack>
      </Stack>
    </Box>
  </Box>
);

export default AuthLayout;
